import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Overview
export const getOverviewShopService = (params) => {
  return http.get(`${base_url}/shop/overview`, { params });
};
// End Overview

// Start Shop Info
export const getShopInfoShopService = () => {
  return http.get(`${base_url}/shop/info`);
};
export const editShopInfoShopService = (data) => {
  return http.put(`${base_url}/shop/info`, data);
};
export const changeShopInfoActiveShopService = () => {
  return http.patch(`${base_url}/shop/info/active`);
};
// End Shop Info

// Start Qr Code
export const checkQrCodeShopService = (data) => {
  return http.post(`${base_url}/shop/qr-code`, data);
};
export const verifyQrCodeShopService = (data) => {
  return http.patch(`${base_url}/shop/qr-code`, data);
};
// End Qr Code
